import { render, staticRenderFns } from "./AccordionItemBase.vue?vue&type=template&id=32240f35&scoped=true&"
import script from "./AccordionItemBase.vue?vue&type=script&lang=js&"
export * from "./AccordionItemBase.vue?vue&type=script&lang=js&"
import style0 from "./AccordionItemBase.vue?vue&type=style&index=0&id=32240f35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32240f35",
  null
  
)

export default component.exports